import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

// Components

import TitleBox from "../../components/TitleBox";
import Buttons from "../../components/Buttons";
import Footer from "../../components/Footer";
import DetailsModal from "../../components/DetailsModal";
import { ArrowLeft } from "react-feather";

import ErrorPage from "../ErrorPage";

import ProviderMasterlist from "./ProviderMasterlist";

const HospitalList = ({ props }) => {
  let navigate = useNavigate();

  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  const [modalProps, setModalProps] = useState({});

  const [isModalActive, setIsModalActive] = useState(false);

  const [providerName, setProviderName] = useState("");

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  useEffect(() => {
    if (props) {
      switch (props.providertype) {
        case "H":
          setProviderName("Hospitals");
          break;
        case "C":
          setProviderName("Medical Clinics");
          break;
        default:
          setProviderName("Dental Clinics");
          break;
      }
    }

    return () => {
      return;
    };
  }, [props]);

  if (!props) {
    return <ErrorPage />;
  } else {
    return (
      <div
        className='hospitals-container'
        style={{
          height: height - 75,
          width: width,
        }}
      >
        <AnimatePresence>
          {isModalActive && (
            <DetailsModal
              setIsModalActive={setIsModalActive}
              props={modalProps}
            />
          )}
        </AnimatePresence>
        <TitleBox
          title={
            props ? `${props.cityname} ${providerName}` : `${providerName}`
          }
        />
        <Buttons
          text={<ArrowLeft />}
          onClick={() => {
            navigate(-1);
          }}
          color='primary'
          style={{
            height: "5px !important",
            position: "absolute",
            top: "5%",
            left: 0,
            borderRadius: "0px 10px 10px 0px",
            padding: "1% 2.5%",
            zIndex: 9,
          }}
          key='back-hospital-list'
        />
        <div className='hospitals-selection'>
          <ProviderMasterlist
            cityCode={props.citycode}
            providerType={props.providertype}
            setIsModalActive={setIsModalActive}
            setModalProps={setModalProps}
          />
        </div>

        <Footer args={{ height, width }} />
      </div>
    );
  }
};

export default HospitalList;
